export const environment = {
  production: true,
  apiUrl : '#{publicApiUrl}',
  defaultLanguage: 'hr',
  defaultLocale: 'hr-HR',
  recordsPerPage:25,
  currencyCutoverDate: '#{Backoffice.currencyCutoverDate}',
  defaultCurrencySuffixAfterCutoverDate: '#{Backoffice.defaultCurrencySuffixAfterCutoverDate}'
};



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/environments/environment.ts